var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-menu'),_c('div',{attrs:{"id":"home-wallet"}},[_c('el-main',{staticStyle:{"margin-top":"100px"}},[(_vm.wallet.connected || _vm.$route.params.walletAddress)?_c('div',[_c('home-wallet')],1):_c('div',[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('connect-wallet')],1)],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }